import {jsx} from 'panel';

import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectEl} from 'common/components/select';
import {EntryPart} from 'common/widgets/query-entry-section/types';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';

import {FilterValueProps} from '../types';

export function FilterObjectValue({
  index,
  activeEntry,
  entryPart,
  filter,
  onSelectMenuChange,
  updateEntry,
  eventNames,
  projectId,
  workspaceId,
  readOnlyMode,
}: FilterValueProps) {
  const isOpen = activeEntry === index && entryPart === EntryPart.FilterValue;

  const [, operator, ...labelParts] = filter.getLabelParts();
  const label = [operator.label, ...labelParts.map((part) => part.label)].join(` `);

  return (
    <SelectEl
      class={{
        'is-placeholder': !filter.isValid(),
      }}
      attrs={{
        elref: `filterValueSelect`,
        open: isOpen,
        theme: `select`,
        'selected-option': filter.isValid() ? label : `Select value...`,
        readonly: readOnlyMode,
      }}
      on={{
        menuChange: (ev) => onSelectMenuChange(ev, index, EntryPart.FilterValue),
      }}
    >
      {isOpen && (
        <PropertyValuesScreenEl
          attrs={{
            elref: `filterValue`,
            slot: `body`,
            'display-value-only': true,
            'event-names': eventNames,
            'property-filter': filter.getAttributes(),
            'project-id': projectId,
            'workspace-id': workspaceId,
          }}
          on={{
            commitPropertyFilter: (ev: CommitPropertyFilterEvent) => updateEntry(ev.detail.propertyFilter),
          }}
        />
      )}
    </SelectEl>
  );
}
